import OwnershipTransfer from "./ownershipTransfer/PluginSetup.js";
import DashboardSetup from "./dashboard/PluginSetup.js";
import Details from "./details/PluginSetup.js";
import Actions from "./actions/PluginSetup.js";
import Attributes from "./attributes/PluginSetup.js";
import Tracking from "./tracking/PluginSetup.js";
export default {
  install: molten => {
    OwnershipTransfer.install(molten);
    Actions.install(molten);
    Details.install(molten);
    DashboardSetup.install(molten);
    Attributes.install(molten);
    Tracking.install(molten);
  }
};